import React from 'react';
import { motion } from 'framer-motion';
import hand_wash75 from '../images/products/THERADERM PRODUCTS FINAL RENDER/HAND WASH 75ML.png';
import hand_wash200 from '../images/products/THERADERM PRODUCTS FINAL RENDER/HAND WASH 200ML.png';
import hand_wash300 from '../images/products/THERADERM PRODUCTS FINAL RENDER/HAND WASH 300ML.png';
import hand_wash500 from '../images/products/THERADERM PRODUCTS FINAL RENDER/HAND WASH 500ML.png';
import hanWas from '../images/prod_ngs/TheraDermBackgroundPictures-08.png';

function Handwash() {
  return (
    <div className="">
      {/* Header Section */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="py-12 text-center"
      >
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-2 font-serif">
          HAND WASH
        </h1>
        <div className="w-48 h-1 bg-white mx-auto mb-4"></div>
        <p className="text-amber-500 text-lg md:text-xl uppercase tracking-wider">
          With Honey & Glycerin
        </p>
      </motion.div>

      {/* Product Section */}
      <motion.div 
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
        className="relative overflow-hidden my-8 mx-auto max-w-6xl rounded-xl shadow-2xl border-t-4 border-amber-500"
        style={{ 
          backgroundImage: `url(${hanWas})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 relative z-10">

          {/* ---------- IMAGE GALLERY WITH PERFECT BOTTOM ALIGNMENT ---------- */}
          <div className="flex flex-col items-center justify-center p-8 lg:p-12">

            {/* FIXED HEIGHT + BOTTOM ALIGNMENT */}
            <div className="flex items-end justify-center space-x-4 md:space-x-6 mb-6 h-72 md:h-80">

              <motion.div whileHover={{ scale: 1.03 }} className="flex items-end transition-all duration-300">
                <img
                  src={hand_wash75}
                  alt="Hand Wash 75ml"
                  className="h-48 md:h-56 w-auto object-contain drop-shadow-lg"
                />
              </motion.div>

              <motion.div whileHover={{ scale: 1.03 }} className="flex items-end transition-all duration-300">
                <img
                  src={hand_wash200}
                  alt="Hand Wash 200ml"
                  className="h-56 md:h-64 w-auto object-contain drop-shadow-lg"
                />
              </motion.div>

              <motion.div whileHover={{ scale: 1.03 }} className="flex items-end transition-all duration-300">
                <img
                  src={hand_wash300}
                  alt="Hand Wash 300ml"
                  className="h-64 md:h-72 w-auto object-contain drop-shadow-lg"
                />
              </motion.div>

              <motion.div whileHover={{ scale: 1.03 }} className="flex items-end transition-all duration-300">
                <img
                  src={hand_wash500}
                  alt="Hand Wash 500ml"
                  className="h-64 md:h-72 w-auto object-contain drop-shadow-lg"
                />
              </motion.div>

            </div>

            <div className="mt-4">
              <p className="text-white text-sm bg-black/30 px-3 py-1 rounded-full">
                Available in <span className="text-amber-300 font-medium">75, 200, 300ml</span> &{' '}
                <span className="text-amber-300 font-medium">500ml</span>
              </p>
            </div>
          </div>

          {/* Product Info */}
          <div className="flex flex-col justify-center p-8 lg:p-12 text-white">
            <motion.h2 
              initial={{ x: 20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="text-3xl md:text-4xl font-bold mb-6 text-center lg:text-left"
            >
              Moisturizing Hand Wash
            </motion.h2>
            
            <motion.p
              initial={{ x: 20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="text-white/90 mb-8 text-center lg:text-left"
            >
              <span className="text-amber-300 font-semibold">THERA DERM's Hand Wash</span> thoroughly cleans your hands while ensuring they remain moisturized and soft, thanks to the nourishing combination of honey and glycerin.
            </motion.p>

            <motion.div
              initial={{ x: 20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="text-center lg:text-left italic text-xl mb-8 font-serif"
            >
              "For <span className="text-amber-300">clean</span> & <span className="text-amber-300">soft</span> hands"
            </motion.div>

          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default Handwash;
